import { StudentIpExamCompleteContent } from './StudentIpExamCompleteContent';
export default StudentIpExamCompleteContent;